import { SvgIconProps } from '@mui/material'
import React from 'react'

const Temp: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width={96}
      height={96}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill='#F4F4F4' />
      <g clipPath='url(#clip0_5057_207827)'>
        <path
          d='M28.1701 58.5472H58.7965C59.0712 58.5472 59.3367 58.4511 59.5472 58.276C59.8414 58.0296 66.5516 52.2571 66.9608 39.7964H34.0687C33.6611 51.1074 27.4813 56.4239 27.4171 56.4769C27.0406 56.795 26.902 57.3147 27.0714 57.777C27.2396 58.2382 27.678 58.5472 28.1701 58.5472Z'
          fill='#8B8B8B'
        />
        <path
          d='M65.8276 32.7649H59.968V31.5929C59.968 30.9367 59.4523 30.421 58.796 30.421C58.1398 30.421 57.6241 30.9367 57.6241 31.5929V32.7649H51.6863V31.5929C51.6863 30.9367 51.1707 30.421 50.5144 30.421C49.8581 30.421 49.3425 30.9367 49.3425 31.5929V32.7649H43.4828V31.5929C43.4828 30.9367 42.9672 30.421 42.3109 30.421C41.6546 30.421 41.139 30.9367 41.139 31.5929V32.7649H35.2793C34.6231 32.7649 34.1074 33.2805 34.1074 33.9368V37.4526H66.9995V33.9368C66.9995 33.2805 66.4839 32.7649 65.8276 32.7649Z'
          fill='#8B8B8B'
        />
        <path
          d='M61.0518 60.0729C60.4154 60.6028 59.6166 60.8912 58.796 60.8912H34.1074V64.407C34.1074 65.0548 34.6316 65.5789 35.2793 65.5789H65.8276C66.4754 65.5789 66.9995 65.0548 66.9995 64.407V51.27C64.7401 56.8133 61.5871 59.6249 61.0518 60.0729Z'
          fill='#8B8B8B'
        />
      </g>
      <defs>
        <clipPath id='clip0_5057_207827'>
          <rect width={40} height={40} fill='white' transform='translate(27 28)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Temp
